module.exports = __webpack_public_path__ + "static/img/banner5.8ef86781.png";